export default function DS_Python() {
  return <div>DS_Python Component</div>;
}
